import { scoreAccent, scoreBarFill } from '../../utils/scoreColors';

function scoreBarColor(v) {
  return scoreBarFill(v);
}

export function MarkerInfoCard({ element }) {
  const d = element.details || {};
  const score = element.score;
  const scoreCol = scoreAccent(score);

  const metrics = [];
  let tipoStruttura = null;
  let alimentazione = null;

  if (element.type === "fermata") {
    if (d["tipo struttura"]) tipoStruttura = String(d["tipo struttura"]);
    if (d["punteggio riconoscibilità"] !== undefined && d["punteggio riconoscibilità"] !== null)       metrics.push({ label: "Riconoscibilità",  value: +d["punteggio riconoscibilità"] });
    if (d["punteggio tabella orari"] !== undefined && d["punteggio tabella orari"] !== null)          metrics.push({ label: "Tabella orari",    value: +d["punteggio tabella orari"] });
    if (d["punteggio segnaletica orizzontale"] !== undefined && d["punteggio segnaletica orizzontale"] !== null) metrics.push({ label: "Segnaletica",     value: +d["punteggio segnaletica orizzontale"] });
  } else if (element.type === "punto_vendita") {
    if (d["riconoscibilità"] !== undefined && d["riconoscibilità"] !== null)     metrics.push({ label: "Riconoscibilità", value: +d["riconoscibilità"] });
    if (d["erogazione servizio"] !== undefined && d["erogazione servizio"] !== null) metrics.push({ label: "Erogazione",      value: +d["erogazione servizio"] });
    if (d["ordine"] !== undefined && d["ordine"] !== null)              metrics.push({ label: "Ordine",           value: +d["ordine"] });
  } else if (element.type === "linea") {
    if (d["voto puntualità"] !== undefined && d["voto puntualità"] !== null)      metrics.push({ label: "Puntualità",     value: +d["voto puntualità"] });
    if (d["voto spazio"] !== undefined && d["voto spazio"] !== null)          metrics.push({ label: "Spazio a bordo", value: +d["voto spazio"] });
    if (d["voto pulizia"] !== undefined && d["voto pulizia"] !== null) metrics.push({ label: "Pulizia",         value: +d["voto pulizia"] });
    if (d["alimentazione"] && typeof d["alimentazione"] === "object") {
      alimentazione = d["alimentazione"];
    }
  }

  const typeLabel = { fermata: "FERMATA", punto_vendita: "PUNTO VENDITA", linea: "LINEA" }[element.type];
  const accentColor = { fermata: "#FFF260", punto_vendita: "#FF852B", linea: "#90EFEF" }[element.type];

  const fuelEntries = alimentazione
    ? Object.entries(alimentazione).filter(([, v]) => v > 0).sort(([, a], [, b]) => b - a)
    : [];

  return (
    <div style={{ fontFamily: "'Inter', sans-serif", width: 268, background: "#fff", paddingBottom: '4px' }}>
      {/* Header */}
      <div style={{
        padding: "14px 16px 11px",
        borderBottom: "1px solid #EEEEE4",
        display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 8,
      }}>
        <div style={{ minWidth: 0 }}>
          <div style={{
            display: "inline-flex", alignItems: "center",
            background: accentColor + "22", borderRadius: 99,
            padding: "2px 8px", marginBottom: 5,
          }}>
            <span style={{ fontSize: 9, fontWeight: 800, letterSpacing: "0.16em",
              color: element.type === "linea" ? "#006E6E" : element.type === "fermata" ? "#353A0A" : "#7a3a00",
              textTransform: "uppercase" }}>
              {typeLabel}
            </span>
          </div>
          <div style={{ fontSize: 14, fontWeight: 700, color: "#1B1C1C", lineHeight: 1.25, wordBreak: "break-word" }}>
            {element.label}
          </div>
          {tipoStruttura && (
            <div style={{ fontSize: 10, color: "#76786C", marginTop: 2 }}>{tipoStruttura}</div>
          )}
        </div>
        {/* Score gauge (matches SideChartPanel gauge style) */}
        {(() => {
          const size = 64;
          const r = (size - 8) / 2;
          const cx = size / 2;
          const cy = size / 2;
          const arc = Math.PI * r;
          const filled = Math.max(0, Math.min(1, score / 10)) * arc;
          return (
            <div style={{
              flexShrink: 0, position: 'relative',
              width: size, height: size / 2 + 12,
            }}>
              <svg width={size} height={size / 2 + 2}>
                <path d={`M ${cx - r} ${cy} A ${r} ${r} 0 0 1 ${cx + r} ${cy}`}
                  fill="none" stroke="#EEEEE4" strokeWidth={5} strokeLinecap="round" />
                <path d={`M ${cx - r} ${cy} A ${r} ${r} 0 0 1 ${cx + r} ${cy}`}
                  fill="none" stroke={scoreCol} strokeWidth={5} strokeLinecap="round"
                  strokeDasharray={`${filled} ${arc}`} />
              </svg>
              <div style={{
                position: 'absolute', bottom: 0, left: 0, right: 0,
                display: 'flex', justifyContent: 'center',
                fontSize: size * 0.24, fontWeight: 700, color: scoreCol, lineHeight: 1,
              }}>
                {score.toFixed(1)}
              </div>
            </div>
          );
        })()}
      </div>

      {/* Bar chart metrics */}
      {metrics.length > 0 && (
        <div style={{ padding: "11px 16px 4px" }}>
          <div style={{ fontSize: 9, fontWeight: 700, letterSpacing: "0.16em",
            color: "#a8a99e", textTransform: "uppercase", marginBottom: 9 }}>
            DETTAGLIO
          </div>
          {metrics.map(({ label, value }) => {
            const col = scoreBarColor(value);
            const pct = Math.min(Math.max(value / 10, 0), 1) * 100;
            return (
              <div key={label} style={{ marginBottom: 9 }}>
                <div style={{ display: "flex", justifyContent: "space-between",
                  alignItems: "baseline", marginBottom: 4 }}>
                  <span style={{ fontSize: 11, fontWeight: 500, color: "#46483D" }}>{label}</span>
                  <span style={{ fontSize: 12, fontWeight: 700, color: col,
                    fontVariantNumeric: "tabular-nums" }}>
                    {value.toFixed(1)}
                  </span>
                </div>
                <div style={{ background: "#F0EFE8", borderRadius: 99, height: 6, overflow: "hidden" }}>
                  <div style={{
                    height: "100%", width: `${pct}%`, borderRadius: 99,
                    background: `linear-gradient(90deg, ${col}cc, ${col})`,
                  }} />
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* Alimentazione (linee) */}
      {fuelEntries.length > 0 && (
        <div style={{ padding: "4px 16px 13px" }}>
          <div style={{ fontSize: 9, fontWeight: 700, letterSpacing: "0.16em",
            color: "#a8a99e", textTransform: "uppercase", marginBottom: 7 }}>
            ALIMENTAZIONE
          </div>
          {/* Stacked bar */}
          <div style={{ display: "flex", borderRadius: 99, overflow: "hidden", height: 8, marginBottom: 6 }}>
            {fuelEntries.map(([k, v], i) => {
              const FUEL_COLORS = {
                diesel: "#fb923c", elettrico: "#A1E340", gas: "#90EFEF",
                ibrido: "#FFF260", idrogeno: "#8C74FF",
              };
              const col = FUEL_COLORS[k.toLowerCase()] ?? "#a8a99e";
              return <div key={k} style={{ flex: v, background: col, marginLeft: i > 0 ? 2 : 0 }} />;
            })}
          </div>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "4px 10px" }}>
            {fuelEntries.map(([k, v]) => (
              <span key={k} style={{ fontSize: 10, color: "#46483D", fontWeight: 500 }}>
                {Math.round(v * 100)}% {k}
              </span>
            ))}
          </div>
        </div>
      )}

      {metrics.length === 0 && fuelEntries.length === 0 && (
        <div style={{ padding: "10px 16px 14px", fontSize: 11, color: "#a8a99e", fontStyle: "italic" }}>
          Nessun dettaglio disponibile
        </div>
      )}
    </div>
  );
}
